import { Instagram, Youtube, Twitter, Music2 } from "lucide-react";
import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "#features" },
      { label: "Integrations", href: "#integrations" },
      { label: "Pricing", href: "#pricing" },
      { label: "Manifesto", href: "#manifesto" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Help center", href: "#" },
      { label: "Community", href: "#" },
      { label: "Templates", href: "#" },
      { label: "Status", href: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy", testid: "footer-legal-privacy" },
      { label: "Terms & Conditions", to: "/terms-conditions", testid: "footer-legal-terms" },
      { label: "Refund Policy", to: "/refund-policy", testid: "footer-legal-refund" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-line bg-surface px-6 pt-20 md:px-12 lg:px-24">
    <div className="mx-auto max-w-6xl">
      <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
        <div className="col-span-2">
          <BrandLogo className="h-8" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-inkMuted">
            One link. Every world. The premium link-in-bio built for creators who care about craft.
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Youtube, Twitter, Music2].map((Icon, i) => (
              <a
                key={i}
                href="#"
                onClick={(e) => e.preventDefault()}
                aria-label="social link"
                className="grid h-10 w-10 place-items-center rounded-full border border-line bg-surfaceAlt text-ink transition-colors hover:border-lime hover:text-lime"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-inkMuted">{col.title}</p>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link to={l.to} data-testid={l.testid} className="strike-link text-sm font-medium text-ink">
                      {l.label}
                    </Link>
                  ) : (
                    <a href={l.href} className="strike-link text-sm font-medium text-ink">
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Oversized wordmark */}
      <div className="mt-16 flex justify-center overflow-hidden">
        <BrandLogo className="h-16 opacity-90 md:h-28 lg:h-36" />
      </div>

      <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-line py-8 text-xs text-inkMuted sm:flex-row">
        <span>© 2026 BREELINK · ACH MEDIA INC. All rights reserved.</span>
        <div className="flex gap-6">
          <Link to="/privacy-policy" data-testid="footer-privacy" className="strike-link">Privacy</Link>
          <Link to="/terms-conditions" data-testid="footer-terms" className="strike-link">Terms</Link>
          <Link to="/refund-policy" data-testid="footer-refund" className="strike-link">Refund</Link>
        </div>
      </div>
    </div>
  </footer>
);
